/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum LoginChallengeTypes {
    Base = '0',
    DeviceCode = 1,
}
